/* eslint-disable react/state-in-constructor */
/**
 *
 * ResourceItem
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link } from 'react-router-dom';
import Card from 'components/Card';
import _isEmpty from 'lodash/isEmpty';
import { isBot, getFinalPrice } from 'utils/stringUtils';
import _has from 'lodash/has';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import ClassNames from 'classnames';
import UserAndExpertRating from 'components/UserAndExpertRating';
import LabelValue from 'components/LabelValue';
import Badge from 'components/Badge';
import Typography from '@material-ui/core/Typography';
import format from 'date-fns/format';
import ResourceLabel from 'components/ResourceLabel';
import Mixpanel from 'utils/mixpanelService';
import VideoEmbedly from 'components/VideoEmbedly';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import AudioCard from 'components/AudioCard';
import DateBadge from 'components/DateBadge';
import ButtonBase from '@material-ui/core/ButtonBase';
import { getBlogType } from 'containers/Article/utils';
import AuthorSubtitle from 'containers/Blogs/components/AuthorSubtitle';
import Image from './Image';
import Title from './Title';
import HighlightsContent from './HighlightsContent';
import FaqItem from './FaqItem';
import TopicItem from './TopicItem';
import HighlightsActiveIcon from './images/highlights-active.svg';
import HighlightsInActiveIcon from './images/highlights-inactive.svg';
import { getNextRecurringDay } from './utils';
const styles = theme => ({
  link: {
    textDecoration: 'none',
    position: 'relative',
  },
  imageLink: {
    textDecoration: 'none',
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  videoLink: {
    // height: 'auto',
  },
  imageWrapper: {
    display: 'flex',
    height: 162,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
    zIndex: 0,
  },
  appImageWrapper: {
    height: 147,
  },
  podcastImageWrapper: {
    height: 227,
  },
  ratingWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 18,
    marginTop: 12,
    padding: '0 15px',
  },
  noUserRatingWrapper: {
    padding: '0 9px',
  },
  titleAndAuthorWrapper: {
    height: 80,
    padding: '0 15px',
  },

  podcastTitleWrapper: {
    height: 'auto',
  },

  eventTitleWrapper: {
    height: 80,
  },
  desktopWrapper: {
    zIndex: 0,
  },
  mobileCardWrapper: {
    borderTop: '2px solid #D8D8D8',
    paddingTop: 10,
  },
  mobileRatingWrapper: {
    justifyContent: 'flex-start',
    padding: 0,
    '&>div': {
      marginRight: 10,
    },
  },
  bigRatingWrapper: {
    height: 70,
  },
  hidden: {
    display: 'none',
  },
  bigImageWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  bigInfoWrapper: {
    marginTop: 20,
  },
  resourceLabelWrapper: {
    justifyContent: 'center',
    display: 'flex',
  },
  newsImageWrapper: {
    margin: '0 15px',
  },
  divider: {
    borderRight: '1px solid #AFBBC1',
    margin: '0 10px',
    height: 10,
  },
  datendOrgsWrapper: {
    display: 'flex',
    padding: '0 20px',
    marginTop: 20,
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  subTitle: {
    ...theme.typography.pxSmall,
    display: '-webkit-box',
    margin: '0 auto',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    height: 40 /* Fallback for non-webkit */,
    padding: '3px 0',
  },
  appRatingWrapper: {
    marginTop: 30,
  },
  podcastRatingWrapper: {
    marginTop: 10,
  },
  highlightBtn: {
    position: 'absolute',
    right: 15,
    top: 17,
    cursor: 'pointer',
  },
  onlineProgramSession: {
    ...theme.typography.pxSmall,
    color: theme.palette.primary.main,
  },
  podcastWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
});

class ResourceItem extends React.PureComponent {
  state = {
    showHighlights: false,
  };

  toggleHighlights = e => {
    e.preventDefault();
    e.stopPropagation();
    this.setState(prevState => ({
      showHighlights: !prevState.showHighlights,
    }));
  };

  redirect = () => {
    const {
      item: {
        name,
        title,
        blog: isBlog,
        type: ctfSubtype,
        subtype: algoliaSubtype,
      },
      type,
      location,
      recommendation,
    } = this.props;

    const fromAlgolia =
      recommendation || location.pathname.split('/')[1] === 'resources';

    let finalType = type;
    let subtype;
    let blog;
    if (type === 'app') {
      const finalSubtype = fromAlgolia ? algoliaSubtype : ctfSubtype;
      if (finalSubtype) {
        if (finalSubtype === 'Online Therapy') subtype = finalSubtype;
        else subtype = 'Apps';
      }
    }
    if (type === 'organization') {
      subtype = fromAlgolia ? algoliaSubtype : ctfSubtype;
    }
    if (type === 'read' || type === 'article') {
      finalType = 'article';
      subtype = fromAlgolia ? algoliaSubtype : ctfSubtype;
      blog = isBlog || false;
    }

    const pageName = location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';
    Mixpanel.track('Resource Card - Clicked', {
      name: name || title,
      type: finalType,
      page: finalPageName,
      path: location.pathname.split('/')[1],
      slug: location.pathname.split('/')[2],
      recommendation,
      subtype: subtype || undefined,
      blog,
    });
  };

  render() {
    const {
      classes,
      item,
      item: {
        shortDescription = '',
        title = '',
        slug,
        person = [],
        name = '',
        image = {},
        imageUrl = '',
        labels = [],
        organization = [],
        nextClassStart = '',
        recurringFrequency = '',
        url = '',
        minutes = '',
        personCollection = {},
        organizationCollection = {},
        publicationDate = '',
        highlights = [],
        costDescription = '',
        cost = '',
        editors = [],
        blogType = null,
      },
      type,
      route,
      height,
      isBig,
      background,
    } = this.props;
    let resourceType = type;
    const isArticle = resourceType === 'article';
    if (isArticle) {
      resourceType = this.props.item.type === 'News' ? 'news' : 'article';
    }
    let file;
    const isCompanyBlog = isArticle && getBlogType(item) === 'cm';
    if (!_isEmpty(imageUrl)) file = imageUrl;
    else if (_has(image, 'url')) file = image.url;
    else if (!_has(image, 'fields') && typeof image === 'object') file = {};
    else if (!_isEmpty(image) && typeof image === 'object')
      ({ file } = image.fields);
    else file = image;
    const resourceName = title || name;
    const resourceAuthor = isCompanyBlog
      ? editors
      : !_isEmpty(person) || (!_isEmpty(person) && blogType === 'cm') // in algolia dev_resources, editors was added in person
      ? person
      : _get(personCollection, 'items');
    const resourceOrg = !_isEmpty(organization)
      ? organization
      : _get(organizationCollection, 'items');
    const withAuthor = [
      'book',
      'podcast',
      'article',
      'event',
      'video',
    ].includes(resourceType);
    const { listenNotesData, showHighlights } = this.state;
    const authorOrOrgLabel = ''; // type === 'podcast' ? 'With' : 'By'; no label for now
    const eventFinalDate = recurringFrequency
      ? getNextRecurringDay(recurringFrequency, nextClassStart)
      : nextClassStart;
    const hideUserRating = resourceType === 'article' && !isBig;
    const isNewsResource = resourceType === 'news';
    const isApp = type === 'app';
    const isPodCast = type === 'podcast';
    const isBook = type === 'book';
    const isProgram = type === 'program';
    const bookTitleArr = isBook && resourceName.split(':');
    const finalResourceName =
      isBook && !_isNil(bookTitleArr[0])
        ? resourceName.split(':')[0]
        : resourceName;
    const subTitle = isPodCast
      ? _get(listenNotesData, 'podcast.title') || shortDescription
      : shortDescription;
    const finalSubtitle = !isBook ? subTitle : bookTitleArr[1];
    if (resourceType === 'faq') return <FaqItem data={item} key={slug} />;
    if (resourceType === 'topic') return <TopicItem data={item} key={slug} />;
    const showHighlightsIcon =
      !_isEmpty(highlights) || !_isEmpty(costDescription) || !_isEmpty(minutes);
    const bot = isBot();
    const finalPrice = getFinalPrice(cost);
    return (
      <Link
        to={`${route}/${slug}`}
        className={classes.link}
        onClick={this.redirect}
      >
        <Card
          height={height}
          background={background}
          borderColor="#E9ECED"
          padding={0}
        >
          <div className={ClassNames(classes.desktopWrapper)}>
            <Grid container>
              {eventFinalDate && (
                <DateBadge
                  date={nextClassStart}
                  frequency={recurringFrequency}
                />
              )}
              <Grid item xs={12}>
                <Badge type={resourceType} minutes={minutes} />
                {showHighlightsIcon && (
                  <ButtonBase
                    className={classes.highlightBtn}
                    onClick={this.toggleHighlights}
                  >
                    <img
                      src={
                        showHighlights
                          ? HighlightsActiveIcon
                          : HighlightsInActiveIcon
                      }
                      alt="highlight"
                    />
                  </ButtonBase>
                )}
              </Grid>
              {!showHighlights ? (
                <>
                  <Grid
                    item
                    xs={12}
                    className={ClassNames(
                      classes.imageWrapper,
                      isNewsResource ? classes.newsImageWrapper : undefined,
                      isApp || isBook ? classes.appImageWrapper : undefined,
                      isPodCast ? classes.podcastImageWrapper : undefined,
                    )}
                  >
                    <div
                      className={ClassNames(
                        classes.imageLink,
                        resourceType === 'video' && classes.videoLink,
                        isPodCast ? classes.podcastWrapper : undefined,
                      )}
                    >
                      {resourceType === 'video' ? (
                        <LazyLoadComponent>
                          <VideoEmbedly
                            title={title}
                            url={url}
                            imageUrl={file}
                            key={url}
                          />
                        </LazyLoadComponent>
                      ) : resourceType === 'podcast' ? (
                        <LazyLoadComponent>
                          <AudioCard
                            data={item}
                            file={file}
                            description={shortDescription}
                            name={finalResourceName}
                            resourceType={resourceType}
                            labels={labels}
                          />
                        </LazyLoadComponent>
                      ) : (
                        <Image file={file} type={resourceType} />
                      )}
                      {!isPodCast && (
                        <ResourceLabel labels={labels} type={resourceType} />
                      )}
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      alignItems="center"
                      className={ClassNames(
                        classes.titleAndAuthorWrapper,
                        resourceType === 'event' && classes.eventTitleWrapper,
                        isPodCast ? classes.podcastTitleWrapper : undefined,
                      )}
                    >
                      {!isPodCast && (
                        <Title title={finalResourceName} type={resourceType} />
                      )}

                      {(isApp || isBook) && (
                        <Typography
                          color="textPrimary"
                          className={classes.subTitle}
                        >
                          {finalSubtitle}
                        </Typography>
                      )}
                      {withAuthor && (
                        <>
                          <Grid item xs={12}>
                            <LabelValue
                              label={authorOrOrgLabel}
                              value={resourceAuthor}
                              isCard
                              type={
                                isCompanyBlog || blogType === 'cm'
                                  ? 'editors'
                                  : 'people'
                              }
                            />
                          </Grid>
                          {(isCompanyBlog || blogType) && (
                            <Grid item xs={12}>
                              <AuthorSubtitle
                                data={resourceAuthor}
                                align="center"
                              />
                            </Grid>
                          )}
                        </>
                      )}
                      {isProgram && (finalPrice > 0 || costDescription) && (
                        <Grid item xs={12}>
                          <Typography
                            color="textPrimary"
                            align="center"
                            className={classes.onlineProgramSession}
                          >
                            {finalPrice === 0 ? costDescription : finalPrice}
                          </Typography>
                        </Grid>
                      )}
                      {['video', 'article'].includes(resourceType) &&
                        _isEmpty(resourceAuthor) &&
                        !_isEmpty(resourceOrg) && (
                          <Grid item xs={12}>
                            <LabelValue
                              value={resourceOrg}
                              type="organizations"
                              isCard
                            />
                          </Grid>
                        )}
                    </Grid>
                  </Grid>
                  {resourceType !== 'organization' &&
                    resourceType !== 'blog' &&
                    !isNewsResource &&
                    !bot && (
                      <Grid
                        item
                        xs={12}
                        className={ClassNames(
                          classes.ratingWrapper,
                          hideUserRating
                            ? classes.noUserRatingWrapper
                            : undefined,
                          isApp || isBook
                            ? classes.appRatingWrapper
                            : undefined,
                          isPodCast ? classes.podcastRatingWrapper : undefined,
                        )}
                      >
                        <UserAndExpertRating data={item} type={resourceType} />
                      </Grid>
                    )}
                  {isNewsResource && (
                    <Grid item xs={12} className={classes.datendOrgsWrapper}>
                      {!_isEmpty(publicationDate) && (
                        <Typography variant="overline" color="textPrimary">
                          {format(publicationDate, 'MMM DD, YYYY')}
                        </Typography>
                      )}
                      {!_isEmpty(publicationDate) &&
                        !_isEmpty(organization) && (
                          <span className={classes.divider} />
                        )}
                      <LabelValue value={organization} type="organizations" />
                    </Grid>
                  )}
                </>
              ) : (
                <HighlightsContent item={item} />
              )}
            </Grid>
          </div>
        </Card>
      </Link>
    );
  }
}
ResourceItem.propTypes = {
  classes: PropTypes.object,
  item: PropTypes.object,
  type: PropTypes.string,
  route: PropTypes.string,
  height: PropTypes.number,
  isBig: PropTypes.bool,
  location: PropTypes.object,
  background: PropTypes.string,
  recommendation: PropTypes.bool,
};

ResourceItem.defaultProps = {
  height: 348,
  background: '#fff',
  recommendation: false,
};

export default compose(
  withRouter,
  withStyles(styles),
)(ResourceItem);
